import { render, staticRenderFns } from "./AppLegend.vue?vue&type=template&id=2e5d8362&"
import script from "./AppLegend.vue?vue&type=script&lang=js&"
export * from "./AppLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports